module.exports = {"id":"189485","name":"Diego Farías","rating":"74","photo":"./data/images/photos/2/189485.png","club":{"name":"Cagliari","logo":"./data/images/clubs/Cagliari.png"},"positions":["ATT","MOC","AD","AG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoFarias0.json
// module id = 1082
// module chunks = 0